<!--Back Button-->
<div class="container d-lg-block d-none py-4">
  <div class="back-btn bg-primary" (click)="goBack()">
    <span class="material-symbols-outlined text-white"> arrow_back_ios_new </span>
  </div>
</div>

<!-- Points Summary -->
<fgb-points-summary-bar [backButtonLink]="'/rewards/raffles'"></fgb-points-summary-bar>

<!--Lotto Details-->
<fgbcl-lotto-details-v2 [lottoId]="id"></fgbcl-lotto-details-v2>
